/* DiscoveryAction.js */

"use strict";

class DiscoveryAction {
    constructor(logger, activeView, DeviceEntity, userSession, userFeedback, jnibAdapter) {
        this._logger = logger;
        this._activeView = activeView;
        this._modalUserFeedback = userFeedback;

        this._targetDevices = {
            method: "multi",
            ids: this._activeView.getSelectedDeviceIds().selectedRows,
        };
        this._DeviceEntity = DeviceEntity;
        this._userSession = userSession;

        this._jnibAdapter = jnibAdapter;
        this._nibApiService = this._jnibAdapter.getNibApiService();

        this.run = this.run.bind(this);
    }
    run() {
        // Solution needs to be loaded first, else we ignore this action and let the user know
        return this._nibApiService
            .doesRefExist({
                orgId: this._userSession.activeOrganization.id,
                ref: "sys/jnib/features/deviceDetect/discoverDeviceJob.jnib",
            })
            .then((exists) => {
                if (exists) {
                    return this._DeviceEntity
                        .runDiscoveryWork(
                            this._userSession.activeOrganization.id,
                            this._targetDevices,
                            {},
                            {launchAndForget: true}
                        )
                        .then((result) => {
                            if (
                                result.failed &&
                                result.failed.length > 0 &&
                                result.failed[0].errorCode === "StartJobError"
                            ) {
                                return Promise.reject(result.failed[0]);
                            } else {
                                return Promise.resolve();
                            }
                        })
                        .catch((err) => {
                            this._logger.warn({error: err}, "SetDefaultConfigAction.run() - Error");
                            return this._modalUserFeedback.displayError(err);
                        });
                } else {
                    this._modalUserFeedback.displayError({
                        errorMsg:
                            "Looks like you don’t have the Device Discovery package installed. Go to Solutions Management to install it.",
                        errorCode: "",
                    });
                    return false;
                }
            })
            .catch((err) => {
                if (err.userRejected) {
                    return Promise.resolve();
                }
                this._logger.warn(
                    {error: err},
                    "SetDefaultConfigAction.run().getNibApiService - Error"
                );
                return this._modalUserFeedback.displayError(err);
            });
    }
}

module.exports = DiscoveryAction;

DiscoveryAction.$inject = [
    "$teve.logger",
    "gameEditor.activeView",
    "$teve.entities.Device",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.jnibAdapter",
];

DiscoveryAction.$displayDetails = {
    type: "Action",
    name: "DiscoveryAction",
    icon: "devicemanager.discovery",
    shown: true,
    title: "Discover devices",
    order: 1,
};
